import React from 'react';
import { cn } from '@/utils/utils';
import { FOCUS } from '@/components/ui/recipes';
import { Notification } from './types/domain.types';

interface NotificationCardProps {
  notification: Notification;
  onClick: (notification: Notification) => void;
}

const formatTime = (timestamp: string) =>
  new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true }).format(new Date(timestamp));

/** A notification as production drew it: a bordered card, tinted while unread, its message wrapping and its time under it. */
const NotificationCard: React.FC<NotificationCardProps> = ({ notification, onClick }) => {
  const unread = !notification.read;
  return (
    // ui-exempt: production's notification card (tinted while unread, the message wrapping, the time on its own line), which ListRow's single-line row cannot draw
    <button
      type="button"
      onClick={() => onClick(notification)}
      className={cn(
        'flex w-full gap-2.5 rounded-lureo-radius border-lureo-border-width p-2.5 text-left font-lureo-font-ui transition-colors',
        unread ? 'border-lureo-berry-ink/20 bg-lureo-berry-ink/10 hover:bg-lureo-berry-ink/15' : 'border-lureo-line bg-lureo-neutral-subtle hover:bg-lureo-neutral',
        FOCUS,
      )}
    >
      <span aria-hidden className={cn('mt-2 h-1.5 w-1.5 shrink-0 rounded-full', unread && 'bg-lureo-berry-ink')} />
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className={cn('text-lureo-14 font-medium leading-5', unread ? 'text-lureo-ink-strong' : 'text-lureo-ink-subtle')}>{notification.subject}</span>
        <span className={cn('text-lureo-14 font-light leading-5', unread ? 'text-lureo-ink' : 'text-lureo-ink-subtle')}>{notification.message}</span>
        <span className="mt-0.5 text-lureo-12 tabular-nums text-lureo-ink-subtlest">{formatTime(notification.createdAt)}</span>
      </span>
    </button>
  );
};

export default NotificationCard;
